import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [res, setRes] = useState({ threads: [], posts: [] });

  useEffect(() => {
    if (q) api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setRes(r.data));
  }, [q]);

  return (
    <div className="pastel-grain min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight">
          Search results
        </h1>
        <p className="text-zinc-600 font-medium mt-1" data-testid="search-query">for "<b>{q}</b>"</p>

        <div className="mt-8">
          <h2 className="font-display text-xl font-bold mb-3">Threads ({res.threads.length})</h2>
          <div className="space-y-3">
            {res.threads.length === 0 && <p className="text-zinc-500 font-medium">No matches.</p>}
            {res.threads.map((t) => (
              <Link to={`/thread/${t.id}`} key={t.id} data-testid={`search-thread-${t.id}`}
                className="block brutal-border brutal-shadow-sm rounded-xl p-4 bg-white brutal-hoverable">
                <h3 className="font-display font-bold">{t.title}</h3>
                <p className="text-sm text-zinc-600 line-clamp-2 font-medium">{t.content}</p>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-8">
          <h2 className="font-display text-xl font-bold mb-3">Posts ({res.posts.length})</h2>
          <div className="space-y-3">
            {res.posts.length === 0 && <p className="text-zinc-500 font-medium">No matches.</p>}
            {res.posts.map((p) => (
              <Link to={`/thread/${p.thread_id}`} key={p.id} data-testid={`search-post-${p.id}`}
                className="block brutal-border brutal-shadow-sm rounded-xl p-4 bg-white brutal-hoverable">
                <p className="text-sm text-zinc-700 line-clamp-3 font-medium">{p.content}</p>
                <div className="text-xs text-zinc-500 mt-1 font-medium">by {p.author_name}</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
